import * as $ from 'jquery';

export function initialize(): void {
    init();
}

const inputSelector = '.js-prettify-select';

function init(): void {
    $(inputSelector).each((index, select) => replace(select));
}

function getClasses(dropdownClass: string): any {
    return {
        wrapper: dropdownClass,
        title: dropdownClass + '__title',
        titleOpen: dropdownClass + '__title--open',
        list: dropdownClass + '__list',
        listOpen: dropdownClass + '__list--open',
        item: dropdownClass + '__item',
        link: dropdownClass + '__link',
        linkSelected: dropdownClass + '__link--selected'
    };
}


function createItem(value: string | number | string[], text: string, currentValue: string | number | string[], cssClass: any): any {
    return $(`
        <li class="${cssClass.item}">
            <a data-value="${value}" class="${cssClass.link}${currentValue === value ? ` ${cssClass.linkSelected}` : ''}" href="">${text}</a>
        </li>
    `);
}

function createDropdown(cssClass: any): any {
    const dropdown = {
        $wrapper: $(`<ul class="${cssClass.wrapper}"><li></li></ul>`),
        $title: $(`<a class="${cssClass.title}" href="" aria-expanded="false">UNASSIGNED</a>`),
        $list: $(`<ul class="${cssClass.list}"></ul>`)
};

    dropdown.$wrapper.children('li').append(dropdown.$title);
    dropdown.$wrapper.children('li').append(dropdown.$list);

    return dropdown;
}

function replace(select): void {
    const cssClass = getClasses(select.dataset.setClass);
    const $select = $(select).hide();
    const dropdown = createDropdown(cssClass);
    const $links = populateItems(
        $select.children('option'),
        dropdown.$list,
        $select.val(),
        cssClass
    );

    setTitle(dropdown.$title, $links, cssClass);
    bindToggle(dropdown, cssClass);
    bindSelect(dropdown, $select, $links, cssClass);

    dropdown.$wrapper.insertAfter($select);
}

function populateItems($options: any, $list: any, currentValue: string | number | string[], cssClass: any): any {
    $options.each((index, option: any) => {
        const $option = $(option);
        $list.append(createItem($option.val(), $option.html(), currentValue, cssClass));
    });

    return $list.find(`.${cssClass.link}`);
}

function setTitle($title: any, $links: any, cssClass: any): void {
    $title.html($links.filter(`.${cssClass.linkSelected}`).html());
}

function bindToggle(dropdown, cssClass) {
    dropdown.$title.on('click', (event) => {
        event.preventDefault();
        dropdown.$title.toggleClass(cssClass.titleOpen);
        dropdown.$list.toggleClass(cssClass.listOpen);
    });
}

function bindSelect(dropdown, $select, $links, cssClass: any) {
    $links.on('click', (event) => {
        event.preventDefault();
        const link = event.target;
        const $link = $(link);

        $select.val(link.dataset.value);
        $select.trigger('change');

        $links.removeClass(cssClass.linkSelected);
        $link.addClass(cssClass.linkSelected);

        dropdown.$title.removeClass(cssClass.titleOpen);
        dropdown.$list.removeClass(cssClass.listOpen);

        setTitle(dropdown.$title, $links, cssClass);
    });
}
